export default __webpack_public_path__ + "static/media/laser_gun.ded1ea83.mp3";